var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isBuilding)?_c('div',{staticClass:"dialog"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"dialog_content"},[_vm._v("功能维护中，暂未开放")]),_vm._v(" "),_c('div',[_c('button',{on:{"click":function($event){_vm.isBuilding = false}}},[_vm._v("确定")])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fed5cfa4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommingSoon.vue
// module id = null
// module chunks = 